import React from 'react';
import { NutritionalInfoItem } from '@/types/strapi';

interface NutritionalInfoDisplayProps {
  items: NutritionalInfoItem[];
  className?: string;
}

const NutritionalInfoDisplay: React.FC<NutritionalInfoDisplayProps> = ({ 
  items, 
  className = '' 
}) => {
  if (!items || items.length === 0) {
    return (
      <p data-component-id="src/components/ui/NutritionalInfoDisplay.tsx:15:6" data-component-path="src/components/ui/NutritionalInfoDisplay.tsx" data-component-line="15" data-component-file="NutritionalInfoDisplay.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B%233d1c1a%5D%20font-tt-norms-regular%20font-normal%20text-base%20leading-%5B23px%5D%22%2C%22textContent%22%3A%22Informaci%C3%B3n%20nutricional%20no%20disponible.%22%7D" className="text-[#3d1c1a] font-tt-norms-regular font-normal text-base leading-[23px]">
        Información nutricional no disponible.
      </p>
    );
  }

  // Dividir los items en columnas de máximo 4 elementos cada una
  const itemsPerColumn = 4;
  const columns: NutritionalInfoItem[][] = [];
  
  for (let i = 0; i < items.length; i += itemsPerColumn) {
    columns.push(items.slice(i, i + itemsPerColumn));
  }

  return (
    <div data-component-id="src/components/ui/NutritionalInfoDisplay.tsx:30:4" data-component-path="src/components/ui/NutritionalInfoDisplay.tsx" data-component-line="30" data-component-file="NutritionalInfoDisplay.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${className}`}>
      {columns.map((column, columnIndex) => (
        <div data-component-id="src/components/ui/NutritionalInfoDisplay.tsx:32:8" data-component-path="src/components/ui/NutritionalInfoDisplay.tsx" data-component-line="32" data-component-file="NutritionalInfoDisplay.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-2%22%7D" key={columnIndex} className="space-y-2">
          <ul data-component-id="src/components/ui/NutritionalInfoDisplay.tsx:33:10" data-component-path="src/components/ui/NutritionalInfoDisplay.tsx" data-component-line="33" data-component-file="NutritionalInfoDisplay.tsx" data-component-name="ul" data-component-content="%7B%22elementName%22%3A%22ul%22%2C%22className%22%3A%22list-disc%20list-inside%20space-y-2%22%7D" className="list-disc list-inside space-y-2">
            {column.map((item) => (
              <li data-component-id="src/components/ui/NutritionalInfoDisplay.tsx:35:14" data-component-path="src/components/ui/NutritionalInfoDisplay.tsx" data-component-line="35" data-component-file="NutritionalInfoDisplay.tsx" data-component-name="li" data-component-content="%7B%22elementName%22%3A%22li%22%2C%22className%22%3A%22text-%5B%233d1c1a%5D%20font-tt-norms-regular%20text-base%20leading-%5B23px%5D%22%7D" 
                key={item.id} 
                className="text-[#3d1c1a] font-tt-norms-regular text-base leading-[23px]"
              >
                <span data-component-id="src/components/ui/NutritionalInfoDisplay.tsx:39:16" data-component-path="src/components/ui/NutritionalInfoDisplay.tsx" data-component-line="39" data-component-file="NutritionalInfoDisplay.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-bold%22%2C%22textContent%22%3A%22%3A%22%7D" className="font-bold">{item.Item}:</span>{' '}
                <span data-component-id="src/components/ui/NutritionalInfoDisplay.tsx:40:16" data-component-path="src/components/ui/NutritionalInfoDisplay.tsx" data-component-line="40" data-component-file="NutritionalInfoDisplay.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-normal%22%7D" className="font-normal">{item.Valor}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default NutritionalInfoDisplay;
